// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   MAIN CONTAINER
========================= */
.analyses-container {
    max-width: 88%;
    margin: 40px auto;
    padding: 32px;
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

/* =========================
   TITLE
========================= */
.analyses-container h2 {
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 32px;
    letter-spacing: 0.05em;
}

/* =========================
   TABLE
========================= */
.job-summary-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
    background: #ffffff;
}

.job-summary-table thead tr {
    background: #334155;
    color: #ffffff;
}

.job-summary-table th {
    padding: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 13px;
}

.job-summary-table td {
    padding: 16px;
    color: #0f172a;
    border-bottom: 1px solid #e5e7eb;
}

.job-summary-table tbody tr:nth-child(even) {
    background: #f8fafc;
}

.job-summary-table tbody tr:hover {
    background: #eef2ff;
}

/* =========================
   BUTTONS (UNIFIED)
========================= */
.view-details-button,
.log-toggle-button,
.results-toggle-button,
.report-toggle-button {
    height: 38px;
    min-width: 140px;
    padding: 0 14px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    color: #ffffff;
    margin-right: 12px;
    transition: all 0.2s ease;
}

/* Individual roles */
.view-details-button {
    background: #6366f1;
}
.view-details-button:hover {
    background: #4f46e5;
    transform: translateY(-1px);
}

.log-toggle-button {
    background: #334155;
}
.log-toggle-button:hover {
    background: #1e293b;
    transform: translateY(-1px);
}

.results-toggle-button {
    background: #0ea5a4;
}
.results-toggle-button:hover {
    background: #0891b2;
    transform: translateY(-1px);
}

.report-toggle-button {
    background: #ca8a04;
}
.report-toggle-button:hover {
    background: #a16207;
    transform: translateY(-1px);
}

/* =========================
   LOG PANEL
========================= */
.execution-log-panel {
    background: #0f172a;
    color: #e5e7eb;
    border-radius: 8px;
    padding: 12px;
    margin-top: 10px;
    max-height: 320px;
    overflow-y: auto;
    font-family: ui-monospace, SFMono-Regular, monospace;
}

.log-header {
    color: #94a3b8;
    font-size: 13px;
    margin-bottom: 6px;
}

.log-line.info { color: #e5e7eb; }
.log-line.error { color: #f87171; font-weight: 600; }

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 768px) {
    .analyses-container {
        max-width: 95%;
        padding: 20px;
    }

    .job-summary-table {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/Analyses.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;;2BAE2B;AAC3B;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;2BAE2B;AAC3B;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;2BAE2B;AAC3B;;;;IAII,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;2BAE2B;AAC3B;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA,iBAAiB,cAAc,EAAE;AACjC,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;;AAEpD;;2BAE2B;AAC3B;IACI;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* =========================\n   MAIN CONTAINER\n========================= */\n.analyses-container {\n    max-width: 88%;\n    margin: 40px auto;\n    padding: 32px;\n    background: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n/* =========================\n   TITLE\n========================= */\n.analyses-container h2 {\n    text-align: center;\n    font-size: 26px;\n    font-weight: 600;\n    color: #0f172a;\n    margin-bottom: 32px;\n    letter-spacing: 0.05em;\n}\n\n/* =========================\n   TABLE\n========================= */\n.job-summary-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 15px;\n    background: #ffffff;\n}\n\n.job-summary-table thead tr {\n    background: #334155;\n    color: #ffffff;\n}\n\n.job-summary-table th {\n    padding: 16px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-size: 13px;\n}\n\n.job-summary-table td {\n    padding: 16px;\n    color: #0f172a;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.job-summary-table tbody tr:nth-child(even) {\n    background: #f8fafc;\n}\n\n.job-summary-table tbody tr:hover {\n    background: #eef2ff;\n}\n\n/* =========================\n   BUTTONS (UNIFIED)\n========================= */\n.view-details-button,\n.log-toggle-button,\n.results-toggle-button,\n.report-toggle-button {\n    height: 38px;\n    min-width: 140px;\n    padding: 0 14px;\n    border-radius: 8px;\n    border: none;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    color: #ffffff;\n    margin-right: 12px;\n    transition: all 0.2s ease;\n}\n\n/* Individual roles */\n.view-details-button {\n    background: #6366f1;\n}\n.view-details-button:hover {\n    background: #4f46e5;\n    transform: translateY(-1px);\n}\n\n.log-toggle-button {\n    background: #334155;\n}\n.log-toggle-button:hover {\n    background: #1e293b;\n    transform: translateY(-1px);\n}\n\n.results-toggle-button {\n    background: #0ea5a4;\n}\n.results-toggle-button:hover {\n    background: #0891b2;\n    transform: translateY(-1px);\n}\n\n.report-toggle-button {\n    background: #ca8a04;\n}\n.report-toggle-button:hover {\n    background: #a16207;\n    transform: translateY(-1px);\n}\n\n/* =========================\n   LOG PANEL\n========================= */\n.execution-log-panel {\n    background: #0f172a;\n    color: #e5e7eb;\n    border-radius: 8px;\n    padding: 12px;\n    margin-top: 10px;\n    max-height: 320px;\n    overflow-y: auto;\n    font-family: ui-monospace, SFMono-Regular, monospace;\n}\n\n.log-header {\n    color: #94a3b8;\n    font-size: 13px;\n    margin-bottom: 6px;\n}\n\n.log-line.info { color: #e5e7eb; }\n.log-line.error { color: #f87171; font-weight: 600; }\n\n/* =========================\n   RESPONSIVE\n========================= */\n@media (max-width: 768px) {\n    .analyses-container {\n        max-width: 95%;\n        padding: 20px;\n    }\n\n    .job-summary-table {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
